module.exports = __webpack_public_path__ + "static/media/14.f8882382.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/14.jpg
// module id = 275
// module chunks = 0